import React from 'react';
import classNames from 'classnames';

import styles from '../AuthPage.module.scss';

import { Input } from '@components/Input';
import { SaveButton } from '@components/ActionButtons/SaveButton';
import { translate } from '@chaika/i18n/helper';
import { Button, ButtonModifiers, ButtonTheme } from '@components/Button';

interface PasswordRecoveryFormProps {
    password: string;
    confirmPassword: string;
    passwordErrorMessage?: string;
    onInputChange(e: React.ChangeEvent<HTMLInputElement>): void;
    onLoginClick(): void;
    onBackButtonClick(): void;
}

export function PasswordRecoveryForm({
    password,
    confirmPassword,
    passwordErrorMessage,
    onInputChange,
    onLoginClick,
    onBackButtonClick,
}: PasswordRecoveryFormProps) {
    const isPasswordValid = password.length > 5;
    const isPasswordsMath = password === confirmPassword;

    return (
        <>
            <div className={classNames([styles.fieldWrapper, !!passwordErrorMessage && styles.smallMargin])}>
                <Input
                    type={'password'}
                    name={'password'}
                    title={translate('password')}
                    autoComplete={'new-password'}
                    value={password}
                    showValidStatus
                    isValid={password.length === 0 ? undefined : isPasswordValid && !passwordErrorMessage}
                    onChange={onInputChange}
                    onKeyDown={e => (e.key === 'Enter' ? onLoginClick() : null)}
                />
                {!!passwordErrorMessage && <span className={styles.errorMessage}>{passwordErrorMessage}</span>}
            </div>
            <div className={classNames([styles.fieldWrapper, styles.smallMargin])}>
                <Input
                    showValidStatus
                    type={'password'}
                    name={'confirmPassword'}
                    title={'Повторите пароль'}
                    autoComplete={'new-password'}
                    isValid={confirmPassword.length < 4 ? undefined : isPasswordsMath}
                    value={confirmPassword}
                    onChange={onInputChange}
                    onKeyDown={e => (e.key === 'Enter' ? onLoginClick() : null)}
                />
            </div>
            <div className={classNames([styles.fieldWrapper, styles.smallMargin, styles.bottomPosition])}>
                <SaveButton
                    modifiers={[ButtonModifiers.InheritWidth]}
                    label={translate('changePassword')}
                    onSaveClick={onLoginClick}
                />
            </div>
            <div className={styles.fieldWrapper}>
                <Button
                    theme={ButtonTheme.Secondary}
                    modifiers={[ButtonModifiers.InheritWidth]}
                    label={translate('back')}
                    onClick={onBackButtonClick}
                />
            </div>
        </>
    );
}
